import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPencilLine: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPencilLine"><Path d="M17 1.68933L2 16.6893V22H7.31066L22.3107 6.99999L17 1.68933Z" fill="currentColor"/><Path d="M12 20.5V22H22V20.5H12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPencilLine;
